import { useEffect } from 'react'

interface UseElementIntersectionObserverProps {
	ref: React.RefObject<HTMLElement>
	disabled?: boolean
	threshold?: number
	onIntersect: () => void
	onInit?: () => void
}

export const useElementIntersectionObserver = ({
	ref,
	disabled = false,
	threshold = 0.5,
	onIntersect,
	onInit,
}: UseElementIntersectionObserverProps) => {
	useEffect(() => {
		const el = ref.current

		if (!el || disabled) return
		if (onInit) onInit()

		const observer = new window.IntersectionObserver(
			entries => {
				const entry = entries[0]
				if (entry.isIntersecting) {
					onIntersect()
				}
			},
			{ threshold }
		)

		observer.observe(el)

		return () => {
			observer.disconnect()
		}
	}, [ref, disabled, threshold, onIntersect, onInit])
}
